import type { MbtiCode } from './types';
import { SITE_DRIVE_IMAGE_MAP } from './driveImageMap';

export interface MbtiTypeMeta {
  code: MbtiCode;
  /** 結果ページ番号（/diagnosis-result{N} の N） */
  pageNumber: number;
  /** 正式タイプ名（Drive画像・driveImageMap.ts が正本） */
  name: string;
  /** Drive画像ファイル名の先頭コード */
  driveCode: string;
}

/** 16タイプのマスタ（URL・タイプ名の正本） */
export const MBTI_TYPE_REGISTRY: readonly MbtiTypeMeta[] = [
  { code: 'PALE', pageNumber: 2, name: 'グルメ弾丸ハンター', driveCode: 'PALE' },
  { code: 'PALZ', pageNumber: 3, name: '美食のんびり族', driveCode: 'PALZ' },
  { code: 'PACE', pageNumber: 4, name: '完璧弾丸トラベラー', driveCode: 'PRAE' },
  { code: 'PACZ', pageNumber: 5, name: '究極の安心旅行者', driveCode: 'PRCZ' },
  { code: 'PRLE', pageNumber: 6, name: '安定志向冒険家', driveCode: 'PRCE' },
  { code: 'PRLZ', pageNumber: 7, name: '計画的隠居旅人', driveCode: 'PRAZ' },
  { code: 'PRCE', pageNumber: 8, name: 'バランス型探検家', driveCode: 'PCLE' },
  { code: 'PRCZ', pageNumber: 9, name: 'ほどほど快適派', driveCode: 'PCLZ' },
  { code: 'SALE', pageNumber: 10, name: '爆速即興トラベラー', driveCode: 'SRAE' },
  { code: 'SALZ', pageNumber: 11, name: '風まかせビーチ族', driveCode: 'SRAZ' },
  { code: 'SACE', pageNumber: 12, name: 'ゆるふわアドベンチャー', driveCode: 'SRCE' },
  { code: 'SACZ', pageNumber: 13, name: '究極の脱力系', driveCode: 'SRCZ' },
  { code: 'SRLE', pageNumber: 14, name: '食い倒れ冒険', driveCode: 'SALE' },
  { code: 'SRLZ', pageNumber: 15, name: 'グルメ放浪詩人', driveCode: 'SALZ' },
  { code: 'SRCE', pageNumber: 16, name: '自由放浪遊牧民', driveCode: 'SCLE' },
  { code: 'SRCZ', pageNumber: 17, name: '窮境のマイペース', driveCode: 'SCLZ' },
] as const;

// driveImageMap と整合チェック（開発時）
if (SITE_DRIVE_IMAGE_MAP.length !== 16) {
  throw new Error(`driveImageMap must have 16 entries, got ${SITE_DRIVE_IMAGE_MAP.length}`);
}

export const MBTI_CODES = MBTI_TYPE_REGISTRY.map((t) => t.code);

export const CODE_TO_PAGE_PATH: Record<MbtiCode, string> = Object.fromEntries(
  MBTI_TYPE_REGISTRY.map((t) => [t.code, `/diagnosis-result${t.pageNumber}`]),
) as Record<MbtiCode, string>;

export const PAGE_NUMBER_TO_CODE: Record<number, MbtiCode> = Object.fromEntries(
  MBTI_TYPE_REGISTRY.map((t) => [t.pageNumber, t.code]),
) as Record<number, MbtiCode>;

export const CODE_TO_META: Record<MbtiCode, MbtiTypeMeta> = Object.fromEntries(
  MBTI_TYPE_REGISTRY.map((t) => [t.code, t]),
) as Record<MbtiCode, MbtiTypeMeta>;
